import React from "react";
import { SystemFonts, store, persistor, loadFonts, loadReducers } from "../structure";
import { UseBootstrapProps } from "./Bootstrap.types";

function useBootstrap({ onLoad, fonts = {}, reducers = {} }: UseBootstrapProps) {
  const [appLoaded, setAppLoaded] = React.useState(false);
  React.useEffect(() => {
    const loadApp = async () => {
      try {
        await loadFonts({
          ...SystemFonts,
          ...fonts,
        });
        loadReducers(reducers);
      } catch (error) {
        console.log(error);
      } finally {
        setAppLoaded(true);
        if (onLoad) onLoad();
      }
    };
    loadApp();
  }, []);

  return { isLoading: !appLoaded, store, persistor };
}

export { useBootstrap };
